import { AuthPagesLayout } from '../../components/authentication';
import { SwitchToDesktopUi } from './SwitchToDesktopUi';

export function SwitchToDesktop() {
  return (
    <AuthPagesLayout form={<SwitchToDesktopUi />} from="switchToDesktop" />
  );
}
